import React from "react";
import PopupModel from "./PopupModel";
import "./Popup.css";


interface PopupProps {
  popupModel: PopupModel;
  closePopup: () => void;
}

const Popup: React.FC<PopupProps> = ({ popupModel, closePopup }) => {

  // if header exists, render header next to the "x", else, render the body
  const renderHeader = popupModel.header && popupModel.header !== "" ? (
    <div className="popup-display-header">
      <div className="popup-display-header-text">
        {popupModel.header}
      </div>
      <button onClick={closePopup} className="popup-display-close-button">
        &times;
      </button>
    </div>
  ) : (
    <div className="popup-display-header">
      <div className="popup-display-body">
        {popupModel.body}
      </div>
      <button onClick={closePopup} className="popup-display-close-button">
        &times;
      </button>
    </div>
  );

  // if there is no header, body will be rendered by header so render nothing
  const renderBody = popupModel.header && popupModel.header !== "" ? (
    <div className="popup-display-body">{popupModel.body}</div>
  ): null;

  return (
    <div className="popup-display-overlay">
      <div className="popup-display-popup" style={{width: popupModel.width || '400px' }}>
        {renderHeader}
        {renderBody}
        {popupModel.buttons.length > 0 && (
          <div className="popup-display-button-container">
            {popupModel.buttons.map((button, index) => (
              <button key={index} onClick={button.onClick} className="popup-display-button">
                {button.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Popup;
